import { activityActionTypes } from './constants';

import type { DayData } from '../types';

export function getReportActivityRequest(date: Date | string, weeks = 3, callback?: () => void) {
	return {
		type: activityActionTypes.GET_REPORT_ACTIVITY_REQUEST,
		payload: {
			date,
			weeks,
			callback,
		},
	};
}

export function getReportActivitySuccess(activity: Record<string, DayData[]>, startedDate: string) {
	return {
		type: activityActionTypes.GET_REPORT_ACTIVITY_SUCCESS,
		payload: {
			activity,
			startedDate,
		},
	};
}

export function getReportActivityError(error: unknown) {
	return {
		type: activityActionTypes.GET_REPORT_ACTIVITY_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function getPreviousReportActivityRequest(date: string) {
	return {
		type: activityActionTypes.GET_PREVIOUS_REPORT_ACTIVITY_REQUEST,
		payload: {
			date,
		},
	};
}

export function getNextReportActivityRequest(date: string, callback?: () => void) {
	return {
		type: activityActionTypes.GET_NEXT_REPORT_ACTIVITY_REQUEST,
		payload: {
			date,
			callback,
		},
	};
}

export function getPlayedDaysRequest(date?: string) {
	return {
		type: activityActionTypes.GET_PLAYED_DAYS_REQUEST,
		payload: {
			date,
		},
	};
}

export function getPlayedDaysSuccess(playedDays: string[]) {
	return {
		type: activityActionTypes.GET_PLAYED_DAYS_SUCCESS,
		payload: {
			playedDays,
		},
	};
}

export function getPlayedDaysError(error: unknown) {
	return {
		type: activityActionTypes.GET_PLAYED_DAYS_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function setActiveDate(activeDate: Date) {
	return {
		type: activityActionTypes.SET_ACTIVE_DATE,
		payload: {
			activeDate,
		},
	};
}

export function setPreviousDate(previousDate: string | null) {
	return {
		type: activityActionTypes.SET_PREVIOUS_DATE,
		payload: {
			previousDate,
		},
	};
}

export function setNextDate(nextDate: string | null) {
	return {
		type: activityActionTypes.SET_NEXT_DATE,
		payload: {
			nextDate,
		},
	};
}
